/// <amd-module name="SuiteCommerce.ProductLeadTime.PDP.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ProductLeadTime.PDP.View", ["require", "exports", "Backbone", "underscore", "sc_product_lead_time_pdp.tpl", "SuiteCommerce.ProductLeadTime.PDP.Configuration", "SuiteCommerce.ProductLeadTime.Utils"], function (require, exports, Backbone_1, _, pdpTemplate, PDP_Configuration_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PDPView = /** @class */ (function (_super) {
        __extends(PDPView, _super);
        function PDPView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = pdpTemplate;
            _this.pdp = options.pdp;
            _this.selectItem();
            _this.model.on('change:productLeadMessage', function () {
                _this.render();
            });
            return _this;
        }
        PDPView.prototype.selectItem = function () {
            var item = this.pdp.getItemInfo();
            var isMatrixItem = this.isMatrix(item);
            var isOneChildSelected = this.pdp.getSelectedMatrixChilds().length === 1;
            if (!isMatrixItem) {
                this.model.item = item.item;
            }
            else if (isMatrixItem && isOneChildSelected) {
                this.model.item = this.pdp.getSelectedMatrixChilds()[0];
            }
            else {
                this.model.item = undefined;
            }
            if (this.model.item && this.model.itemRequiresLeadTimeMessage()) {
                this.calculateMessage();
            }
            else {
                this.model.productLeadMessage = '';
            }
        };
        PDPView.prototype.isMatrix = function (item) {
            if (item.options) {
                return _.find(item.options, function (option) {
                    return option.isMatrixDimension;
                });
            }
            return false;
        };
        PDPView.prototype.calculateMessage = function () {
            var _this = this;
            this.model.showLeadTime = false;
            if (PDP_Configuration_1.PDPConfiguration.message && PDP_Configuration_1.PDPConfiguration.messageFormat === 'Date Countdown') {
                this.model.fetchLeadTime().done(function () {
                    var leadTime = _this.model.totalDays;
                    if (leadTime < 1) {
                        leadTime = 1;
                    }
                    _this.calculateShowLeadTime();
                    _this.model.productLeadMessage = PDP_Configuration_1.PDPConfiguration.message.replace(/(\[\[leadtime]])|(\{{leadtime}})/g, String(leadTime));
                });
            }
            else if (PDP_Configuration_1.PDPConfiguration.message && PDP_Configuration_1.PDPConfiguration.messageFormat === 'Date') {
                this.model.fetchLeadTimeDate().done(function () {
                    _this.calculateShowLeadTime();
                    _this.model.productLeadMessage = PDP_Configuration_1.PDPConfiguration.message.replace(/(\[\[leadtime]])|(\{{leadtime}})/g, _this.formatDate(_this.model.leadTimeDate, PDP_Configuration_1.PDPConfiguration.dateFormat));
                });
            }
        };
        PDPView.prototype.calculateShowLeadTime = function () {
            var hasPurchaseOrder = !!this.model.purchaseOrder || this.model.purchaseOrder === 0;
            var hasLeadTime = !!this.model.leadTime;
            if (hasPurchaseOrder && hasLeadTime) {
                this.model.showLeadTime = true;
            }
        };
        PDPView.prototype.formatDate = function (receivedDate, dateFormat) {
            var newDate = dateFormat;
            var monthReplaced = false;
            var date = new Date(receivedDate);
            var replaceMonth = function (monthLength, format) {
                var matched = newDate.match(monthLength);
                if (matched && !monthReplaced) {
                    monthReplaced = true;
                    return newDate.replace(monthLength, date.toLocaleString('en-us', { month: format }));
                }
                return newDate;
            };
            var ua = navigator.userAgent;
            var isOldIe = ua.indexOf('MSIE ') > -1;
            if (isOldIe) {
                return String(receivedDate);
            }
            newDate = newDate.replace('yyyy', date.toLocaleString('en-us', { year: 'numeric' }));
            newDate = newDate.replace('yy', date.toLocaleString('en-us', { year: '2-digit' }));
            newDate = newDate.replace('dd', date.toLocaleString('en-us', { day: '2-digit' }));
            newDate = newDate.replace('d', date.toLocaleString('en-us', { day: 'numeric' }));
            newDate = replaceMonth('mmmm', 'long');
            newDate = replaceMonth('mmm', 'short');
            newDate = replaceMonth('mm', '2-digit');
            newDate = replaceMonth('m', 'numeric');
            return newDate;
        };
        PDPView.prototype.getContext = function () {
            return {
                productLeadTimeMessage: Utils_1.Utils.translate(this.model.get('productLeadMessage')),
                showLeadTime: this.model.get('showLeadTime'),
            };
        };
        return PDPView;
    }(Backbone_1.View));
    exports.PDPView = PDPView;
});
